export default {"src":"/_next/static/media/instagram-color-icon.b9daf14b.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};